// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  ICreateQuestionAnswerRequest,
  TCreateQuestionAnswerModel,
  IMappers,
  TCreateQuestionAnswerResponse,
  ICreateQuestionAnswerResponse,
  ICreateQuestionAnswerResponseError,
} from './types';

export const defaultConfig: TCreateQuestionAnswerModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'newbuilding-reviews',
  pathApi: '/v1/create-question-answer/',
  requestType: 'json',
} as TCreateQuestionAnswerModel;

export function createCreateQuestionAnswerModel(parameters: ICreateQuestionAnswerRequest): TCreateQuestionAnswerModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ICreateQuestionAnswerOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: ICreateQuestionAnswerRequest;
}

export async function fetchCreateQuestionAnswer<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ICreateQuestionAnswerOptions<TResponse200, TResponse400>): Promise<
  TCreateQuestionAnswerResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createCreateQuestionAnswerModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ICreateQuestionAnswerResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as ICreateQuestionAnswerResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TCreateQuestionAnswerResponse;
}
